import React from 'react';
import PropTypes from 'prop-types';

import Button from '@Components/Button';

import './HeatmapFullScreenButton.custom.scss';

function getFullScreenInfo(isFullScreen) {
  if (isFullScreen) {
    return {
      icon: 'contract',
      label: 'Exit Full Screen',
    };
  }

  return {
    icon: 'expand',
    label: 'Full Screen',
  };
}

function getButtonConfiguration(isLaptop) {
  if (isLaptop) {
    return {
      type: 'link',
      iconClassName: 'els-btn-icon',
      size: 'tiny',
    };
  }

  return {
    type: 'tertiary',
    iconClassName: '',
    size: 'sm',
  };
}

export default function HeatmapFullScreenButton(props) {
  const { setFullScreenMode, heatmapFullScreenModeIndicator, isLaptop } = props;
  const { icon, label } = getFullScreenInfo(heatmapFullScreenModeIndicator);
  const { type, iconClassName, size } = getButtonConfiguration(isLaptop);

  return (
    <Button
      onClick={() => {
        setFullScreenMode(!heatmapFullScreenModeIndicator);
      }}
      buttonConfig={{
        label,
        type,
        size,
        e2eName: 'heatmap-full-screen',
      }}
      iconConfig={{
        position: 'before',
        name: icon,
        className: iconClassName,
      }}
    />
  );
}

HeatmapFullScreenButton.defaultProps = {
  setFullScreenMode: () => {},
};

HeatmapFullScreenButton.propTypes = {
  isLaptop: PropTypes.bool.isRequired,
  setFullScreenMode: PropTypes.func,
  heatmapFullScreenModeIndicator: PropTypes.bool.isRequired,
};
